export default __webpack_public_path__ + "static/react-native-school-9c9c77bb30e3d3fbe8fef4c2d03e20b9.png";